import { ILicenseItem } from 'models/IUserData'
import axAPI from '../httpConfig'

export default class AuthApiService {
	static getUserInfoById = async (userId: number) => {
		return axAPI.get(`auth/users/${userId}/`)
	}
	static putChangeUserData = async (
		updateData: Record<string, unknown> | FormData,
		currentUserId: number,
	) => {
		return axAPI({
			method: 'PUT',
			url: `auth/users/${currentUserId}/`,
			data: updateData,
		})
	}
	static putChangeUserAvatar = async (
		userId: number,
		data: FormData | { avatar: null },
		headers?: Record<string, string>,
	) => {
		return axAPI({
			method: 'PUT',
			url: `auth/users/${userId}/change_avatar`,
			data,
			headers,
		})
	}
	static postNewUser = async (updateData: Record<string, unknown>) => {
		return axAPI({
			method: 'POST',
			url: 'auth/users/',
			data: updateData,
		})
	}
	static postForcePassword = async (updateData: Record<string, unknown>) => {
		return axAPI({
			method: 'POST',
			url: 'auth/force_password',
			data: updateData,
		})
	}
	static postNewRole = async (data: Record<string, unknown>) => {
		return axAPI({
			method: 'POST',
			url: 'auth/roles',
			data: data,
		})
	}
	static putChangeUserAvatarMe = async (
		data: FormData | { avatar: null },
		headers?: Record<string, string>,
	) => {
		return axAPI({
			method: 'PUT',
			url: '/auth/users/me/change_avatar',
			data,
			headers,
		})
	}
	static putChangeUserMe = async (data: Record<string, unknown>) => {
		return axAPI({
			method: 'PUT',
			url: '/auth/users/me',
			data,
		})
	}
	static getLicenses = async (): Promise<ILicenseItem[]> => {
		const res = await axAPI.get('/auth/licenses')
		return res.data as ILicenseItem[]
	}
}
